import getRequest from '@helpers/api/get';

export const getTransactionsList = ({
  transactionType,
  limit = 10,
  offset = 0,
  transactionCategory = 'output',
  entityJurisdictionId,
} = {}) =>
  getRequest('vFile/vgTransactionType/', {
    limit,
    offset,
    entity_jurisdiction: entityJurisdictionId,
    io: transactionCategory,
    gs: transactionType,
    distinct_names: true,
  });
